/**
 * Esperilux RH-inspired product detail page
 * Production build: 1.0.0 (2026-08-06)
 *
 * Creates a compact right-panel summary and native details accordions without
 * deleting the theme's original product-content markup.
 */
(function () {
  'use strict';

  var LABELS = {
    'description': 'Details',
    'specifications': 'Dimensions & Specifications',
    'shipping & return': 'Shipping & Returns',
    'shipping & returns': 'Shipping & Returns'
  };

  var mountQueued = false;

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function displayLabel(value) {
    var original = cleanText(value);
    return LABELS[original.toLowerCase()] || original;
  }

  function createIntro(productInfo, source) {
    var meta = productInfo.querySelector('.product-meta');
    var title = meta && meta.querySelector('.product-meta__title');

    if (!meta || !title) return;

    if (!meta.querySelector('.erh-product-byline')) {
      var siteName = document.querySelector(
        'meta[property="og:site_name"]'
      );

      var byline = document.createElement('p');

      byline.className = 'erh-product-byline';
      byline.textContent =
        'By ' +
        cleanText(
          (siteName && siteName.content) || 'Esperilux'
        );

      title.insertAdjacentElement('afterend', byline);
    }

    if (!meta.querySelector('.erh-product-intro')) {
      var sourceIntro = source.querySelector(
        '.product-description p'
      );

      var introText = cleanText(
        sourceIntro && sourceIntro.textContent
      );

      if (introText) {
        var intro = document.createElement('p');

        intro.className = 'erh-product-intro';
        intro.textContent = introText;

        var bylineNode = meta.querySelector(
          '.erh-product-byline'
        );

        bylineNode.insertAdjacentElement(
          'afterend',
          intro
        );
      }
    }
  }

  function createDetails(source) {
    var container = document.createElement('div');

    container.className = 'erh-product-details';
    container.setAttribute(
      'aria-label',
      'Product information'
    );

    var items = source.querySelectorAll(
      '.product-tabs__tab-item-wrapper'
    );

    items.forEach(function (item) {
      var sourceButton = item.querySelector(
        '.collapsible-toggle'
      );

      var sourceContent = item.querySelector(
        '.product-tabs__tab-item-content'
      );

      if (!sourceButton || !sourceContent) return;

      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var label = document.createElement('span');
      var icon = document.createElement('span');
      var content = document.createElement('div');

      details.className = 'erh-product-detail';

      label.textContent = displayLabel(
        sourceButton.textContent
      );

      icon.className = 'erh-product-detail__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '+';

      content.className =
        'erh-product-detail__content rte';

      content.innerHTML = sourceContent.innerHTML;

      summary.appendChild(label);
      summary.appendChild(icon);

      details.appendChild(summary);
      details.appendChild(content);

      container.appendChild(details);
    });

    return container.children.length
      ? container
      : null;
  }

  function mount() {
    mountQueued = false;

    var productInfo = document.querySelector(
      '.shopify-section--main-product .product__info'
    );

    var source = document.querySelector(
      '.product-content'
    );

    if (!productInfo || !source) return;

    createIntro(productInfo, source);

    if (
      !productInfo.querySelector(
        '.erh-product-details'
      )
    ) {
      var details = createDetails(source);

      if (details) {
        productInfo.appendChild(details);
      }
    }

    if (
      productInfo.querySelector(
        '.erh-product-details'
      )
    ) {
      source.setAttribute(
        'data-erh-source',
        'true'
      );

      if (observer) observer.disconnect();

      document.body.classList.add(
        'esperilux-rh-pdp-ready'
      );
    }
  }

  function queueMount() {
    if (mountQueued) return;

    mountQueued = true;
    window.requestAnimationFrame(mount);
  }

  var observer = new MutationObserver(queueMount);
  observer.observe(document.getElementById('main') || document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('variant:change', queueMount);
  document.addEventListener('esperilux:product:loaded', queueMount);
  document.addEventListener('shopify:section:load', queueMount);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      mount,
      { once: true }
    );
  } else {
    mount();
  }

}());